import styled from "@emotion/styled";

export const PendingStatusMessageContainer = styled.div({
	display: "flex",
	flexDirection: "column",
	gap: "16px",
	alignItems: "center",
	justifyContent: "center",
	textAlign: "center",
	padding: "40px",
	boxSizing: "border-box",
	height: "100%"
});

export const PendingStatusMessage = styled.div({
	display: "flex",
	flexDirection: "column",
	gap: "16px",
	alignItems: "center",
	justifyContent: "center",
	textAlign: "center",
	boxSizing: "border-box"
});

export const PendingStatusMessageTitle = styled("h5")(({ theme }) => ({
	...theme.project.typography.heading.h5,
	color: theme.project.colors.primaryColors.main,
	margin: 0
}));

export const PendingStatusMessageSubtitle = styled("p")(({ theme }) => ({
	...theme.project.typography.body.body2,
	color: theme.palette.text.primary,
	margin: 0
}));
